import { Box, Stack } from '@mui/material';
import { WsInputNumber, WsSelect, WsSelectObj, CircleDollarIcon } from 'wisestep-base';

import { CurrencyTypeDropDownOptions } from '../../../utils/CurrencyHelper';
import FilterControlProps from '../models/FilterControlProps';

import WsAccordion from './WsAccordion';

const defaultCurrencies: WsSelectObj[] = CurrencyTypeDropDownOptions;
const defaultUnitTimes: WsSelectObj[] = [
  {
    label: 'Per Hour',
    value: 'PerHour',
  },
  {
    label: 'Per Annum',
    value: 'PerAnnum',
  },
  {
    label: 'Per Day',
    value: 'PerDay',
  },
  {
    label: 'Per Month',
    value: 'PerMonth',
  },
];

const SalaryRangeFilter = ({
  title = 'Salary Range',
  selectArray = defaultCurrencies,
  selectArray1 = defaultUnitTimes,
  disabled = false,
  infoText,
  showAccordionIcon,
}: FilterControlProps) => (
  <WsAccordion
    title={title}
    disabled={disabled}
    infoText={infoText}
    {...(showAccordionIcon && { startIcon: <CircleDollarIcon /> })}
  >
    <Box>
      <Stack direction="row" spacing={2} p={2}>
        <WsSelect name="salaryRange.currency" label="Currency" selectArray={selectArray} />
        <WsSelect name="salaryRange.unitTime" label="Unit Time" selectArray={selectArray1} />
      </Stack>
      <Stack direction="row" spacing={2} p={2}>
        <WsInputNumber name="salaryRange.min" label="Min" />
        <WsInputNumber name="salaryRange.max" label="Max" />
      </Stack>
    </Box>
  </WsAccordion>
);

export default SalaryRangeFilter;
